module.exports = __webpack_public_path__ + "img/Schumann's Bistro-01.7ee21bb2.svg";